export default [{
  name: "s400PatientList",
  toUrl: '/main/service/service400/patient/list',
  title: "患者列表",
  menuId: "6c8e601a-2f7b-4868-8dd1-aacfa2d8a38b",
  normal: require('../../assets/image/icon/Home.png'),
  active: require('../../assets/image/icon/Home-on.png'),
}, {
  name: "s400PatientForm",
  toUrl: '/main/service/service400/patient/form',
  title: "添加患者",
  menuId: "98cda9a0-c4eb-4c74-968e-e5c82c270cc2",
  normal: require('../../assets/image/icon/Workbench.png'),
  active: require('../../assets/image/icon/Workbench-on.png'),
}, {
  name: "s400QuestionList",
  toUrl: '/main/service/service400/question/list',
  title: "质疑管理",
  menuId: "F8BE3B15-563E-A006-03F1-16E46D3C1A09",
  normal: require('../../assets/image/icon/Mine.png'),
  active: require('../../assets/image/icon/Mine-on.png'),
}, {
  name: "s400PatientFollowList",
  toUrl: '/main/service/service400/patient/followList',
  title: "随访列表",
  menuId: "dbff3de6-2d07-4627-b33c-7c0ca9bc57b9",
  normal: require('../../assets/image/icon/CommonWork.png'),
  active: require('../../assets/image/icon/CommonWork-on.png'),
}, {
  name: "s400Mine",
  toUrl: '/Mine',
  title: "我的",
  menuId: "6c8e601a-2f7b-4868-8dd1-aacfa2d8a38b",
  normal: require('../../assets/image/icon/Mine.png'),
  active: require('../../assets/image/icon/Mine-on.png'),
}]
